import { useListOrganizationMembers, useRemoveMemberMutation } from '@/queries/organizations.queries';
import { useDisclosure, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export function useTeamPage() {
	const { id } = useParams<{ id: string }>();
	const { t } = useTranslation();
	const query = useListOrganizationMembers(id);
	const modalDisclosure = useDisclosure();
	const removeMemerMutation = useRemoveMemberMutation();
	const toast = useToast();

	function removeMember(memberId: string) {
		return removeMemerMutation
			.mutateAsync({ orgId: id, memberId })
			.then(() => {
				toast({
					title: t('Member removed'),
					status: 'success',
				});
			})
			.catch(() => {
				toast({
					title: t('Error'),
					status: 'error',
				});
			});
	}

	return {
		t,
		query,
		organizationId: id,
		modalDisclosure,
		removeMember,
	};
}
